// @ is an alias to /src
import $ from 'jquery';
import AOS from 'aos';

import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';

import { REDIRECT_URLS } from '@/constants';

export default {
  name: 'Home',

  components: {
    SharedHeader,
    SharedFooter,
  },

  data: () => {
    return {
      timer: new Date().getTime(),
    };
  },

  created() {
    window.location.href = REDIRECT_URLS.LANDING_PAGE;
    //window.scrollTo(0, 0);
    //
    //setTimeout(function () {
    //  $('.carousel').carousel();
    //  AOS.init({
    //    easing: 'ease-in-out-sine',
    //    once: true,
    //  });
    //}, 0);
  },
};
